/**
 * WEB sheet: the size rule alone (`SizedSheet`). Web has no gorhom provider, so a compact web window
 * draws the React Native `Modal` bottom sheet; `presentation` and `wrapContent` are ignored here.
 */
import React from "react";

import { InlineSheet, SizedSheet, useInlineSheets, type SheetProps } from "./shared";

export * from "./shared";

export function Sheet(props: SheetProps) {
  return useInlineSheets() ? <InlineSheet {...props} /> : <SizedSheet {...props} />;
}

export default Sheet;
